/** Petits utilitaires d'interface du shell. */
import React from 'react';

/** Largeur de la fenêtre (mise à jour au redimensionnement). */
export function useLargeur(): number {
  const [l, setL] = React.useState(() => window.innerWidth);
  React.useEffect(() => {
    const f = () => setL(window.innerWidth);
    window.addEventListener('resize', f);
    return () => window.removeEventListener('resize', f);
  }, []);
  return l;
}

/** Initiales (VB) pour l'avatar du dock. */
export function initiales(prenom: string, nom: string, email: string): string {
  const i = `${prenom.charAt(0)}${nom.charAt(0)}`.toUpperCase();
  return i || email.slice(0, 2).toUpperCase();
}
